<template>
    <div>
        <template v-if="role_type=='Admission'">
            <!-- Admission -->
            <template v-if="user_type=='Parent'">
                <!-- Parent -->
                <!-- {{parent_fees_stats}} -->
                <v-card>
                    <v-card-text>
                        <v-row>
                            <v-col sm="3">
                                <b>Child Name</b>
                            </v-col>
                            <v-col sm="3">
                                <b>Total Fees</b>
                            </v-col>
                            <v-col sm="3">
                                <b> Paid</b>
                            </v-col>
                            <v-col sm="3">
                                <b> Balance</b>
                            </v-col>
                        </v-row>
                        <v-row v-for="fs in parent_fees_stats" :key="fs.grno">
                            <v-col sm="3">
                                {{fs.name}}
                            </v-col>
                            <v-col sm="3">
                                {{fs.total_fees}}
                            </v-col>
                            <v-col sm="3">
                                {{fs.paid_till_now}}
                            </v-col>
                            <v-col sm="3">
                                {{fs.balance}}
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </template>
            <template v-else-if="user_type=='Employee'">
                <!-- Employee
        {{this.staff_admission_stats}}
        
        {{this.staff_admission_form_stats}} -->
            </template>
        </template>
        <template v-else-if="role_type=='Account'">
            <!-- Account -->
            <template v-if="user_type=='Parent'">Parent</template>
            <template v-else-if="user_type=='Employee'">
                <!-- {{month_collection_graph}} -->
                <v-card>
                    <v-card-text justify="center">
                        <v-row>
                            <v-col sm="3">
                                <v-combobox dense required v-model="curr_type" :items="graph_type" item-text="name" item-value="value" label="Graph" outlined />
                            </v-col>
                        </v-row>
                        <chart @click="onClick" :options="month_collection_graph" :loading="month_collection_graph_load"></chart>
                    </v-card-text>
                </v-card>
            </template>
        </template>
    </div>
</template>
<script>
    import axios from "axios";
    export default {
        data: () => ({
            //admission
            role_type: null,
            parent_fees_stats: null,
            user_type: null,
            staff_admission_stats: null,
            staff_admission_form_stats: null,
            // account
            month_collection: null,
            //line graph
            graph_type: [
                {
                    name: "Line",
                    value: "line",
                },
                {
                    name: "Bar",
                    value: "bar",
                },
            ],
            curr_type: {
                name: "Line",
                value: "line",
            },
            month_collection_graph: {
                title: {
                    text: "Collection in Rs",
                    x: "center",
                },
                xAxis: {
                    type: "category",
                    data: [],
                },
                yAxis: {
                    type: "value",
                },
                series: [
                    {
                        data: [],
                        type: "line",
                        label: {
                            normal: {
                                show: true,
                                position: "top",
                            },
                        },
                    },
                ],
            },
            month_collection_graph_load: false,
        }),
        methods: {
            onClick(event, instance) {
                console.log(arguments);
                console.log(arguments[0].name);
                console.log(arguments[0].value);
            },
        },
        watch: {
            curr_type() {
                this.month_collection_graph.series[0].type = this.curr_type.value;
            },
        },
        mounted() {
            this.fees_stats = null;
            this.user_type = null;
            this.month_collection = null;
            this.role_type = this.$store.getters.role_type;
            if (this.role_type == null) {
                this.$router.push("/home");
                return;
            } else {
                return; //will add later
                var link = "";
                if (this.role_type == "Admission") {
                    link = "/dashboard/admission";
                } else if (this.role_type == "Account") {
                    link = "/dashboard/account";
                    this.month_collection_graph_load = true;
                }
                if (link == "") return;
                axios
                    .post(link)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            if (res.data.status == "SUCCESS") {
                                this.user_type = res.data.user_type;
                                //Admission
                                if (this.role_type == "Admission") {
                                    this.parent_fees_stats = res.data.parent_fees_stats;
                                    this.staff_admission_stats = res.data.staff_admission_stats;
                                    this.staff_admission_form_stats = res.data.staff_admission_form_stats;
                                }
                                //Account
                                if (this.role_type == "Account") {
                                    //this.month_collection = res.data.month_collection
                                    this.month_collection_graph.xAxis.data = res.data.x_axis_data;
                                    this.month_collection_graph.series[0].data = res.data.series;
                                }
                            } else {
                                alert(res.data.status_reason);
                            }
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.month_collection_graph_load = false;
                    });
            }
        },
    };
</script>
